import { z } from 'zod';

export const activitySchema = z.object({
  name: z.string().min(1, 'Activity is required'),
  date: z.string().min(1, 'Date is required'),
  durationInMinutes: z.number().min(1, 'Duration is required'),
  note: z.string().min(1, 'Note is required').max(1000, 'Note cannot exceed 1000 characters'),
});

export type ActivityFormData = z.infer<typeof activitySchema>;
